module.exports = __webpack_public_path__ + "img/MBBank.c42808ce.png";